import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import { StyledTextField } from "../../../../components/forms/styles/formFieldStyles";

const WorkflowDetailsForm = ({
  workflowName: initialWorkflowName = "",
  workflowDescription: initialWorkflowDescription = "",
  onWorkflowNameChange,
  onWorkflowDescriptionChange,
}) => {
  const colors = useColors();
  const [localWorkflowName, setLocalWorkflowName] =
    useState(initialWorkflowName);
  const [localWorkflowDescription, setLocalWorkflowDescription] = useState(
    initialWorkflowDescription
  );

  useEffect(() => {
    setLocalWorkflowName(initialWorkflowName);
  }, [initialWorkflowName]);

  useEffect(() => {
    setLocalWorkflowDescription(initialWorkflowDescription);
  }, [initialWorkflowDescription]);

  return (
    <>
      <Typography variant="caption" sx={{ color: colors.text_help }}>
        Add key details
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          marginBottom: "16px",
        }}
      >
        <StyledTextField
          fieldName="workflowName"
          label="Workflow Name"
          value={localWorkflowName}
          onChange={(e) => setLocalWorkflowName(e.target.value)}
          onBlur={() => onWorkflowNameChange(localWorkflowName)}
          InputLabelProps={{
            shrink: localWorkflowName !== "",
          }}
          required
        />
        <StyledTextField
          label="Workflow Description"
          fieldName="workflowDescription"
          value={localWorkflowDescription}
          onChange={(e) => setLocalWorkflowDescription(e.target.value)}
          onBlur={() => onWorkflowDescriptionChange(localWorkflowDescription)}
          InputLabelProps={{
            shrink: localWorkflowDescription !== "",
          }}
          required
        />
      </Box>
    </>
  );
};

export default WorkflowDetailsForm;
